import React, { useState } from "react";

/**
 * 時間帯ごとの「便をどれくらい拾えているか」。
 *
 * 1 系列なので凡例は付けない（見出しが系列名を兼ねる）。長さで大小を
 * 表すので、**縦軸は必ず 0 から。**折れ線と違って棒は切ってはいけない。
 *
 * 色は 1 色。濃淡で大小を重ねて表すと、長さと明度が二重に同じことを
 * 言うだけで読み取りは良くならない。
 */

const WIDTH = 720;
const HEIGHT = 190;
const PAD = { top: 12, right: 12, bottom: 30, left: 44 };

export default function CoverageBars({ rows }) {
  const [hover, setHover] = useState(null);

  const usable = rows.filter((r) => r.ratio !== null && r.ratio !== undefined);

  if (usable.length === 0) {
    return <p className="anl-empty">まだ測れていません。次回の抽出で表示されます。</p>;
  }

  const innerW = WIDTH - PAD.left - PAD.right;
  const innerH = HEIGHT - PAD.top - PAD.bottom;

  // 2px は面と面のあいだの隙間。隣り合う棒がくっついて 1 本に見えるのを防ぐ
  const slot = innerW / usable.length;
  const barW = Math.max(4, slot - 2);

  const y = (v) => PAD.top + innerH - v * innerH;

  return (
    <div className="anl-chart">
      <svg
        viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
        className="anl-chart__svg"
        role="img"
        aria-label="時間帯ごとの観測できている割合"
      >
        {[0, 0.25, 0.5, 0.75, 1].map((t) => (
          <g key={t}>
            <line
              x1={PAD.left} x2={WIDTH - PAD.right} y1={y(t)} y2={y(t)}
              stroke="#d1fae5" strokeWidth="1"
            />
            <text x={PAD.left - 6} y={y(t) + 4} textAnchor="end" className="anl-chart__tick">
              {Math.round(t * 100)}%
            </text>
          </g>
        ))}

        {usable.map((r, i) => {
          const height = Math.max(1, innerH * r.ratio);

          return (
            <g
              key={r.hour}
              onMouseEnter={() => setHover(r)}
              onMouseLeave={() => setHover(null)}
            >
              {/* 当たり判定は棒より広く取る。細い棒は掴めない */}
              <rect
                x={PAD.left + i * slot} y={PAD.top}
                width={slot} height={innerH}
                fill="transparent"
              />
              <rect
                x={PAD.left + i * slot + (slot - barW) / 2}
                y={y(r.ratio)}
                width={barW}
                height={height}
                rx="4"
                fill="#047857"
                opacity={hover === null || hover.hour === r.hour ? 1 : 0.45}
              />
              <text
                x={PAD.left + i * slot + slot / 2} y={HEIGHT - 10}
                textAnchor="middle" className="anl-chart__tick"
              >
                {r.hour}
              </text>
            </g>
          );
        })}
      </svg>

      {hover && (
        <div className="anl-chart__tip">
          <strong>{hover.hour}時台</strong>
          <span>便{hover.trips}</span>
          <span>拾えている割合{Math.round(hover.ratio * 1000) / 10}%</span>
        </div>
      )}
    </div>
  );
}
